import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { emailSubscribe } from '../../apis/userAPI';
import './regularUserManagePage.css';
import SidebarNav from '../../components/SidebarNav';
import ChangePasswordModal from '../../components/ChangePasswordModal';

const ReviewerUserManagementPage = () => {
  const [user, setUser] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = location.state;

  useEffect(() => {
    setUser(currentUser);
    setIsSubscribed(currentUser.email_sub);
  }, [currentUser]);

  const handleSubscription = async () => {
    try {
      await emailSubscribe({ email: user.email });
      setIsSubscribed(!isSubscribed);
    } catch (error) {
      console.error('There was an error updating subscription!', error);
    }
  };

  // Navigate to the main page
  const handleHome = () => {
    navigate('/main', { state: { currentUser } });
  };

  // Navigate to the charts page
  const handleCharts = () => {
    navigate('/charts', { state: { currentUser } });
  };

  const handleTools = () => {
    navigate('/tools', { state: { currentUser } });
  };

  return (
    <div className="main-page-container">
      <SidebarNav
        activePage="users"
        onHome={handleHome}
        onCharts={handleCharts}
        onTools={handleTools}
        onLogout={() => navigate('/login')}
      />

      {/* Main content */}
      <div className="main-content">
        {/* Header */}
        <header className="header">
          <div>
            <h2 className="text-lg font-semibold">Welcome, {user?.first_name}</h2>
          </div>
        </header>

        {/* Page content */}
        <div className="container space-y-6">
          <h2 className="page-title">Users</h2>

          {/* User Information Card */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Your Information</h3>
            </div>
            <div className="table-container">
              <table className="table">
                <tbody>
                  <tr>
                    <td className="font-semibold">Email</td>
                    <td>{user?.email}</td>
                  </tr>
                  <tr>
                    <td className="font-semibold">First Name</td>
                    <td>{user?.first_name}</td>
                  </tr>
                  <tr>
                    <td className="font-semibold">Last Name</td>
                    <td>{user?.last_name}</td>
                  </tr>
                  <tr>
                    <td className="font-semibold">Role</td>
                    <td>{user?.role}</td>
                  </tr>
                  <tr>
                    <td className="font-semibold">Subscription Status</td>
                    <td>
                      <div className="flex items-center space-x-4">
                        <span>{isSubscribed ? 'Subscribed' : 'Not Subscribed'}</span>
                        <button
                          onClick={handleSubscription}
                          className={`px-3 py-1 text-sm font-medium leading-5 text-white transition-colors duration-150 rounded-md ${
                            isSubscribed
                              ? 'bg-red-600 hover:bg-red-700'
                              : 'bg-green-600 hover:bg-green-700'
                          }`}
                        >
                          {isSubscribed ? 'Unsubscribe' : 'Subscribe'}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Change Password Card */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Change Password</h3>
            </div>
            <div className="p-4">
              <button
                onClick={() => setShowPasswordModal(true)}
                className="px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-md active:bg-blue-600 hover:bg-blue-700 focus:outline-none focus:shadow-outline-blue"
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>

      <ChangePasswordModal
        open={showPasswordModal}
        targetEmail={user?.email}
        onClose={() => setShowPasswordModal(false)}
        onSuccess={() => {
          setShowPasswordModal(false);
          alert('Password changed successfully');
        }}
      />
    </div>
  );
};

export default ReviewerUserManagementPage;
